import { Box, Modal, Typography, TextField } from "@mui/material";
import React, { useState } from "react";
import s from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

export default function ListCategoryModal({
                                              open,
                                              onClose,
                                              title,
                                              list,
                                              onDelete,
                                              onEdit,
                                              loading,
                                          }) {
    const [editItem, setEditItem] = useState(null);
    const [editedName, setEditedName] = useState("");

    const handleEditChange = (e) => {
        setEditedName(e.target.value);
    };

    const handleEditSave = (id) => {
        onEdit(id, editedName);
        setEditItem(null);
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "80vh", // Чтобы модалка не выходила за пределы экрана
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {loading ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flex: 1,
                        }}
                    >
                        <div className="loader"></div>
                    </div>
                ) : (
                    <>
                        <div className={s.header}>
                            <Typography variant="h6">{title}</Typography>
                            <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
                        </div>

                        <div
                            style={{
                                flexGrow: 1,
                                overflowY: "auto",
                                marginTop: "16px",
                                paddingRight: "8px",
                            }}
                            className="custom-scrollbar"
                        >
                            {list.length === 0 ? (
                                <Typography variant="body2" color="textSecondary">
                                    Нет данных
                                </Typography>
                            ) : (
                                list.map((item) => (
                                    <div className={s.listBox} key={item.ID}>
                                        {editItem === item.ID ? (
                                            <TextField
                                                value={editedName}
                                                onChange={handleEditChange}
                                                fullWidth
                                                autoFocus
                                            />
                                        ) : (
                                            <p>{item?.name}</p>
                                        )}
                                        <div className={s.rowIcon}>
                                            {editItem === item.ID ? (
                                                <button onClick={() => handleEditSave(item.ID)}>
                                                    <CheckIcon
                                                        sx={{
                                                            cursor: "pointer",
                                                            color: "#006bd6",
                                                        }}
                                                    />
                                                </button>
                                            ) : (
                                                <EditIcon
                                                    onClick={() => {
                                                        setEditItem(item.ID);
                                                        setEditedName(item.name);
                                                    }}
                                                    sx={{
                                                        cursor: "pointer",
                                                        color: "rgba(194, 158, 255, 1)",
                                                    }}
                                                />
                                            )}
                                            <DeleteOutlineOutlinedIcon
                                                onClick={() => onDelete(item.ID)}
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "rgba(255, 107, 107, 1)",
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </>
                )}
            </Box>
        </Modal>
    );
}
